import { useMemo } from "react";
import { Policy, Quote } from "../types/Quote.interface";
import { BREED_TRUSTPILOT_CONFIG, BreedTrustpilotEntry } from "../components/TrustPilotCarousel/BreedTrustpilotConfig";

interface UseBreedTrustpilotResult {
    breedConfig: BreedTrustpilotEntry | null;
    matchedBreedName: string | null;
}

function findBreedTrustpilotConfig(policies?: Policy[]): UseBreedTrustpilotResult {
    if (!policies?.length) {
        return { breedConfig: null, matchedBreedName: null };
    }

    for (const policy of policies) {
        const breedName = policy.breedName;
        if (breedName && breedName in BREED_TRUSTPILOT_CONFIG) {
            return {
                breedConfig: BREED_TRUSTPILOT_CONFIG[breedName]!,
                matchedBreedName: breedName
            };
        }
    }

    return { breedConfig: null, matchedBreedName: null };
}

export function useBreedTrustpilot(quote?: Quote): UseBreedTrustpilotResult {
    const policies = quote?.policies;

    return useMemo(() => findBreedTrustpilotConfig(policies), [policies]);
}
